//
import Model from '@/models/Model'

/**
 * 
 */
export default class HrContractStructure extends Model {

  /**
   * 
   */
  get hr_contract_period_name() {
    return this.getProperty('hr_contract_period.name', '-')
  }

  /**
   * 
   */
  get hr_contract_type_name() {
    return this.getProperty('hr_contract_type.name', '-')    
  }

  /**
   * 
   */
  resource() {
    return 'hr_contract_structure'
  }

  /**
   * 
   */
  toCreate() {
    return this.clean([
      'structure_name',
      'hr_contract_type_id',
      'hr_contract_period_id',
      'weekly_hours',
      'collation',
      'mobilization',
      'base_salary',
    ])
  }
  
  /**
   * 
   */
  toUpdate() {    
    return this.clean([
      'structure_name',
      'hr_contract_type_id',
      'hr_contract_period_id',
      'id',
      'weekly_hours',
      'collation',
      'mobilization',
      'base_salary',
    ])
  }
}
